"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var common_tags_1 = require("common-tags");
var DotChart = /** @class */ (function (_super) {
    __extends(DotChart, _super);
    function DotChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Whether the chart is horizontally layouted, i.e. gravity is left or right. */
        _this._isInversedX = false;
        /** Whether the vertical scale should be inversed, i.e. gravity is bottom or top. */
        _this._isInversedY = false;
        return _this;
    }
    DotChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_maxX":
            case "_minX":
            case "_maxY":
            case "_minY":
                return utils_1.parseNumberWithAuto(value);
            case "_yFunc":
            case "_xFunc":
            case "_classFunc":
            case "_labelFunc":
                return utils_1.parseFunc(value);
            case "_gravity":
                return {
                    top: __1.Gravity.Top, bottom: __1.Gravity.Bottom, left: __1.Gravity.Left, right: __1.Gravity.Right,
                }[value];
            case "_radius":
                return utils_1.parseNumberOrFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    DotChart.prototype.defaultOptions = function () {
        return {
            _gravity: __1.Gravity.Bottom,
            _radius: 5,
            _maxX: null,
            _minX: null,
            _maxY: null,
            _minY: null,
            _yFunc: function (d) { return d.value; },
            _xFunc: function (d) { return d.x; },
            _classFunc: function (d) { return d.class; },
            _labelFunc: function (d) { return d.value.toString(); },
        };
    };
    DotChart.prototype.init = function () {
        var _this = this;
        this._scaleX = d3.scaleLinear();
        this._scaleY = d3.scaleLinear();
        this._toolTip = __1.tooltip.create("dottip");
        this._groups = this.appendGroupT(_1.Component).data([]).options({
            _x: function (d) { return _this._scaleX(_this._xFunc(d)); },
            _y: function (d) { return _this._scaleY(_this._yFunc(d)); },
            class: function (d) { return _this._classFunc(d); },
        });
        this._circles = this._groups.appendT(element_1.Circle).options({
            _anchor: 4 /* Middle */ | 32 /* Center */,
            _r: function (d) { return _this._radius(d); },
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._circles.dom)
                    .renderHTML(function (d, _) {
                    return common_tags_1.oneLineTrim(templateObject_1 || (templateObject_1 = __makeTemplateObject(["x: ", ",<br>\n                                y: ", ",<br>\n                                ", "\n                                ", "\n                            "], ["x: ", ",<br>\n                                y: ", ",<br>\n                                ", "\n                                ", "\n                            "])), _this._xFunc(d), _this._yFunc(d), _this._isConstR ? "" : "r: " + _this._radius(d) + "<br>", _this._classFunc ? "class: " + _this._classFunc(d) + "<br>" : "");
                });
            },
        });
        this._labels = this._groups.appendT(element_1.Text).options({
            _text: function (d) { return _this._labelFunc ? _this._labelFunc(d) : null; },
            _anchor: 16 /* Left */ | 8 /* Bottom */,
        });
    };
    DotChart.prototype.prepare = function () {
        var _this = this;
        _super.prototype.prepare.call(this);
        this._gravity = this.getOption("_gravity");
        this._xFunc = this.getOption("_xFunc", null, null, null, true);
        this._yFunc = this.getOption("_yFunc", null, null, null, true);
        this._classFunc = this.getOption("_classFunc", null, null, null, true);
        var radius = this.getOption("_radius");
        // if r is a constant, don't display its radius in tooltip
        this._isConstR = !isNaN(radius);
        this._radius = this._isConstR ? (function (_) { return radius; }) : radius;
        this._labelFunc = this.getOption("_labelFunc", null, null, null, true);
        this._isInversedX = this._gravity === __1.Gravity.Right || this._gravity === __1.Gravity.Top;
        this._isInversedY = this._gravity === __1.Gravity.Bottom || this._gravity === __1.Gravity.Right;
        var _cachedWidth = this._getGeometry("_width", true);
        var _cachedHeight = this._getGeometry("_height", false);
        this._maxY = this._getMinOrMax(this._yFunc, true, this.getOption("_maxY"));
        this._maxX = this._getMinOrMax(this._xFunc, true, this.getOption("_maxX"));
        this._minY = this._getMinOrMax(this._yFunc, false, this.getOption("_minY"));
        this._minX = this._getMinOrMax(this._xFunc, false, this.getOption("_minX"));
        this._scaleX.domain([this._minX, this._maxX]).nice()
            .range(this._isInversedX ? [_cachedWidth, 0] : [0, _cachedWidth]);
        this._scaleY.domain([this._minY, this._maxY]).nice()
            .range(this._isInversedY ? [_cachedHeight, 0] : [0, _cachedHeight]);
        this._groups.data(this.datum);
        this.setupProxy({
            yAxis: function (axis) {
                axis.options({
                    _scale: _this._scaleY,
                    _gravity: _this._isInversedX ? __1.Gravity.Right : __1.Gravity.Left,
                    _x: _this._isInversedX ? _cachedWidth : 0,
                });
            },
            xAxis: function (axis) {
                axis.options({
                    _scale: _this._scaleX,
                    _gravity: _this._isInversedY ? __1.Gravity.Bottom : __1.Gravity.Top,
                    _y: _this._isInversedY ? _cachedHeight : 0,
                });
            },
            dot: "_circles",
            label: "_labels",
        });
    };
    DotChart.prototype._getMinOrMax = function (func, isMax, custom) {
        return custom ? custom : (isMax ? d3.max(this.datum, func) : d3.min(this.datum, func));
    };
    return DotChart;
}(_1.Component));
exports.DotChart = DotChart;
var templateObject_1;
//# sourceMappingURL=dot-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/dot-chart.js
// module id = 1163
// module chunks = 0 1